import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    SrgQuestionnaireContainer,
    SrgQuestionnaireOverlay,
    SrgQuestionnaireCloseIcon,
} from 'src/domains/players/state/srgQuestionnaire/SrgQuestionnaire.style';
import { SrgQuestionnaireState } from './SrgQuestionnaireState';
import { SrgFooterDescription } from 'src/domains/players/state/srgQuestionnaire/SrgFooterDescription';
import { SrgContent } from 'src/domains/players/state/srgQuestionnaire/srgContent/SrgContent';
import { SrgVerdict } from 'src/domains/players/state/srgQuestionnaire/SrgVerdict';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { UsersState } from 'src/domains/players/state/UsersState';

export const SrgQuestionnaire = observer('SrgQuestionnaire', (): JSX.Element | null => {
    const common = useCommon();
    const usersState = UsersState.get(common);
    const languagesState = LanguagesState.get(common);
    const configComponents = ConfigComponents.get(common);
    const { operatorFullName, accountHelperMail, srgQuestionnaireFailedVersion } = configComponents.config;

    const [state] = useState(() => new SrgQuestionnaireState(usersState));

    if (state.showSrgForm && usersState.isSrgModalOpen) {
        return (
            <SrgQuestionnaireOverlay data-test='srg-questionnaire'>
                <SrgQuestionnaireContainer>
                    {state.srgPassed === null ? (
                        <SrgQuestionnaireCloseIcon onClick={usersState.toggleSrgModal} />
                    ) : null}
                    {state.srgPassed === null ? (
                        <SrgContent
                            state={state}
                            languagesState={languagesState}
                            userName={state.userBasicData?.name}
                            operatorFullName={operatorFullName}
                            questionSet={state.questionSet}
                        />
                    ) : (
                        <SrgVerdict
                            operatorFullName={operatorFullName}
                            srgPassed={state.srgPassed}
                            languagesState={languagesState}
                            handleCloseModal={usersState.toggleSrgModal}
                            srgQuestionnaireFailedVersion={srgQuestionnaireFailedVersion}
                            accountHelperMail={accountHelperMail}
                        />
                    )}
                    <SrgFooterDescription
                        isGreetingPart={state.currentSrgStep === 0}
                        languagesState={languagesState}
                        accountHelperMail={accountHelperMail}
                        showMoreDescription={state.showMoreDescription}
                        toggleDescription={state.toggleDescription}
                        showToggleInfo={state.showToggleInfo}
                    />
                </SrgQuestionnaireContainer>
            </SrgQuestionnaireOverlay>
        );
    }

    return null;
});
